import React, { useState, useEffect } from "react";
import { PMNDPModal } from "../components";
import "./add-bags.css";
import { pmndpAPI } from "../../../services/pmndp.api";
import { usePMNDPNotification } from "../hooks/usePMNDPNotification";

const AddBagsModal = ({ isOpen, onClose, patient, onSuccess, bagData: editBagData }) => {
  const { showSuccess, showError } = usePMNDPNotification();
  const [bagData, setBagData] = useState({
    appointment_date: "",
    capd_bag_no: "",
    capd_expiry_date: "",
    no_of_bags: "",
    last_collected_date: "",
    next_due_date: "",
    upload_prescription: null,
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    if (editBagData) {
      setBagData({
        appointment_date: editBagData.appointment_date || "",
        capd_bag_no: editBagData.capd_bag_no || "",
        capd_expiry_date: editBagData.capd_expiry_date || editBagData.capd_batch_expiry_date || "",
        no_of_bags: editBagData.no_of_bags || "",
        last_collected_date: editBagData.last_collected_date || "",
        next_due_date: editBagData.next_due_date || "",
        upload_prescription: null,
      });
    }
  }, [editBagData]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setBagData((prev) => ({ ...prev, [name]: value }));
  };

  const handleFileChange = (e) => {
    setBagData((prev) => ({ ...prev, upload_prescription: e.target.files[0] }));
  };

  const handleSave = async () => {
    try {
      setIsSubmitting(true);

      const formData = new FormData();
      formData.append("id", editBagData?.id || 0);
      formData.append("appointment_date", bagData.appointment_date || "");
      formData.append("capd_bag_no", bagData.capd_bag_no || "");
      formData.append("last_collected_date", bagData.last_collected_date || "");
      formData.append("next_due_date", bagData.next_due_date || "");
      formData.append("no_of_bags", bagData.no_of_bags || "");
      formData.append("patient_id", patient?.id || "");
      formData.append("capd_expiry_date", bagData.capd_expiry_date || "");
      formData.append("exist_prescription", editBagData?.prescription_path || "");
      if (bagData.upload_prescription) {
        formData.append("upload_prescription", bagData.upload_prescription);
      }

      await pmndpAPI.saveBag(formData);
      showSuccess(
        editBagData
          ? "Bag updated successfully!"
          : "Bag added successfully!"
      );
      onSuccess?.();
      onClose();
    } catch (error) {
      console.error("Error saving bag:", error);
      showError(
        error?.response?.data?.message ||
        error?.message ||
        "Failed to save bag. Please try again."
      );

    } finally {
      setIsSubmitting(false);
    }
  };

  const footer = (
    <div className="addbags-footer">
      <button className="btn btn-light" onClick={onClose} disabled={isSubmitting}>
        Cancel
      </button>
      <button className="btn btn-primary" onClick={handleSave} disabled={isSubmitting}>
        {isSubmitting ? "Saving..." : "Save"}
      </button>
    </div>
  );

  return (
    <PMNDPModal
      isOpen={isOpen}
      onClose={onClose}
      title={editBagData ? "Edit Bag" : "Add Bags"}
      size="large"
      footer={footer}
    >

      <div className="addbags-container">

        {/* Patient Info */}
        <div className="addbags-patient-info">
          <div><b>ABHA Number/Health ID:</b> {patient?.abha_number || "NA"}</div>
          <div><b>ABHA Address:</b> {patient?.abha_address || "NA"}</div>
          <div><b>Patient Name:</b> {patient?.patient_name || "NA"}</div>
        </div>

        {/* Visit Date */}
        <div className="addbags-visit">
          <label>Visit Date :</label>
          <input
            type="date"
            name="appointment_date"
            className="form-control mb-0"
            value={bagData.appointment_date}
            onChange={handleChange}
          />
        </div>

        {/* Form */}
        <div className="addbags-grid">

          <div>
            <label>CAPD Batch No.*</label>
            <input
              name="capd_bag_no"
              className="form-control"
              placeholder="CAPD Bag No."
              value={bagData.capd_bag_no}
              onChange={handleChange}
            />
          </div>

          <div>
            <label>CAPD Batch Expiry Date*</label>
            <input
              type="date"
              name="capd_expiry_date"
              className="form-control"
              value={bagData.capd_expiry_date}
              onChange={handleChange}
            />
          </div>

          <div>
            <label>No. of Bags Issued*</label>
            <input
              name="no_of_bags"
              className="form-control"
              placeholder="Bags"
              value={bagData.no_of_bags}
              onChange={handleChange}
            />
          </div>

          {!editBagData?.id && (
            <div>
              <label>Last Collected Date</label>
              <input
                type="date"
                name="last_collected_date"
                className="form-control"
                value={bagData.last_collected_date}
                onChange={handleChange}
              />
            </div>
          )}
          
          <div>
            <label>Next Due Date*</label>
            <input
              type="date"
              name="next_due_date"
              className="form-control"
              value={bagData.next_due_date}
              onChange={handleChange}
            />
          </div>

          <div className="upload-box">
            <label>Upload Prescription</label>
            <input
              type="file"
              name="upload_prescription"
              className="form-control"
              onChange={handleFileChange}
            />
            <small>(pdf/doc/png/xlsx/txt/jpeg, Max size:2MB)</small>
          </div>

        </div>

      </div>

    </PMNDPModal>
  );
};

export default AddBagsModal;